export default __webpack_public_path__ + "static/media/meeting.ded82fb7.jpg";